<template>
    <!-- componente de jerson -->
    <div class="content-wrapper">
        <div class="row" v-if="showForm == false">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('subcontract_title')" :directory="$t('list')" :icon="'grid'" />
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button" class="btn btn-success btn-with-shadow" @click="exportAll">
                        {{ $t('export_all') }}
                    </button>
                </div>
            </div>
        </div>
        <app-table v-if="showForm == false" :id="tableId" :options="options" @action="getListAction"
            :selected-url="selectedUrl" />
    </div>
</template>

<script>
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../Config/ApiUrl.js";
import { SUBCONTRACTS_EXPORT } from "../../../Config/ApiUrl.js";
import { urlGenerator } from "../../../Helpers/AxiosHelper.js";
import { TableHelpers } from './mixins/TableHelpers.js';

export default {
    extends: CoreLibrary,
    name: "subcontractList",
    mixins: [TableHelpers],
    data() {
        return {
            SUBCONTRACTS_EXPORT,
            showForm: false,
            selectedUrl: '',
            tableId: 'advance-table',
            rowData: {},
            options: {
                name: 'AdvanceTable',
                url: actions.SUBCONTRACTS_DATA,
                showHeader: true,
                enableHighlights: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                    },
                ],
                filters: [
                    {
                        "title": this.$t('date'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "last7Days", "nextYear"]
                    },
                    {
                        title: this.$t('search_and_select'),
                        type: "search-and-select-filter",
                        key: "serverside_select",
                        settings: {
                            url: actions.SUBCONTRACTS_SERVER_SEARCH_SELECT, // this url will hit every search action
                            modifire: (v) => {
                                return { id: v.id, name: v.name }
                            },
                            per_page: 10, // default 10, you can change it any number. min 10 encourage to use
                            queryName: 'search_selectable', // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
                            loader: 'app-pre-loader', // default app-overlay-loder
                            multiple: true, // default false, if you need to select multiple item so make it true
                            params: {
                                'type': 'type1',
                                'isWanted': true
                            } // params object will be appended with your url after search param like '../endpoint?last_name=shishir&type=type1&isWanted=true'
                        },
                        listValueField: 'name'
                    },
                ],
                showFilter: false,
                showSearch: true,
                showCount: false,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },

    created() {
        this.options.columns = [...this.tableColumns, this.actionObj];
        this.searchAndSelectFilterOptions();
    },
    beforeRouteLeave(to, from, next) {
        next();
    },

    methods: {
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;
            if (actionObj.title == 'Delete') {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.showForm = true;
                const rowId = rowData.id; 
                this.$router.push({ name: 'sub-contracts-detail', query: { id: rowId } });
            }
        },

        searchAndSelectFilterOptions() {
            this.axiosGet(actions.SUBCONTRACTS_SERVER_SEARCH_SELECT).then(response => {        
                let name = this.options.filters.find(element => element.title === this.$t('search_and_select'));        
                if (response.data) {       
                    name.option = response.data.data.map(item => {
                        return {
                            id: item.number,
                            value: item.number
                        }
                    });
                }
            });
        },

        exportAll() {
            window.location.replace(urlGenerator(SUBCONTRACTS_EXPORT))
        },
    },
}
</script>
